import { AdFormatsEnum } from '@src/components/AdFormatsTab';
import website from '@src/constants/website';

export const videoList: Array<{ type: AdFormatsEnum; video: string; poster?: string }> = [
  {
    type: AdFormatsEnum.Rewarded,
    video: `${website.staticBaseUrl}/web/official/adformat-assets/260429/rewarded.mp4`,
    poster: `${website.staticBaseUrl}/web/official/adformat-assets/260429/rewarded.webp`,
  },
  {
    type: AdFormatsEnum.Interstitial,
    video: `${website.staticBaseUrl}/web/official/adformat-assets/260429/interstitial.mp4`,
    poster: `${website.staticBaseUrl}/web/official/adformat-assets/260429/interstitial.webp`,
  },
  {
    type: AdFormatsEnum.Native,
    video: `${website.staticBaseUrl}/web/official/adformat-assets/260429/native.mp4`,
    poster: `${website.staticBaseUrl}/web/official/adformat-assets/260429/native.webp`,
  },
  {
    type: AdFormatsEnum.Banner,
    video: `${website.staticBaseUrl}/web/official/adformat-assets/260429/banner.mp4`,
    poster: `${website.staticBaseUrl}/web/official/adformat-assets/260429/banner.webp`,
  },
  {
    type: AdFormatsEnum.AppOpen,
    video: `${website.staticBaseUrl}/web/official/adformat-assets/260429/app-open.mp4`,
    poster: `${website.staticBaseUrl}/web/official/adformat-assets/260429/app-open.webp`,
  },
];